<bmcore-button [styleName]="'icon-40-column-gap-4'" (click)="handleToggleBeatLikeStatus($event)">
  @if (likeInfo?.userLike) {
    <bmcore-like-icon [height]="iconSize" [width]="iconSize" fillColor="#FF4A4A"></bmcore-like-icon>
  }

  @if (!likeInfo?.userLike) {
    <bmcore-like-outline-icon [height]="iconSize" [width]="iconSize"></bmcore-like-outline-icon>
  }

  @if (showLikesCount) {
    <p class="like-btn__count" [class.like-btn__count--inactive]="!likeInfo?.userLike">
      {{ likeInfo?.likesCount }}
    </p>
  }
</bmcore-button>
